import { render, staticRenderFns } from "./IdeaDetail.vue?vue&type=template&id=5bc1aeb0&scoped=true&"
import script from "./IdeaDetail.vue?vue&type=script&lang=js&"
export * from "./IdeaDetail.vue?vue&type=script&lang=js&"
import style0 from "./IdeaDetail.vue?vue&type=style&index=0&id=5bc1aeb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc1aeb0",
  null
  
)

export default component.exports